import dynamic from 'next/dynamic';
import {DrupalNode} from "next-drupal";

const SearchPage = dynamic(() => import('@/components/templates/key_value_page/key_value_page--search').then(mod => mod.SearchPage));
const NewsPage = dynamic(() => import('@/components/templates/key_value_page/key_value_page--news').then(mod => mod.NewsPage));
const EventsPage = dynamic(() => import('@/components/templates/key_value_page/key_value_page--events').then(mod => mod.EventsPage));
const PressReleasesPage = dynamic(() => import('@/components/templates/key_value_page/key_value_page--press-release').then(mod => mod.PressReleasesPage));
const DocumentLibraryPage = dynamic(() => import('@/components/templates/key_value_page/key_value_page--document-library').then(mod => mod.DocumentLibraryPage));
const ContactUsPage = dynamic(() => import('@/components/templates/key_value_page/key_value_page--contact-us').then(mod => mod.ContactUsPage));
const SearchDistributorLabPage = dynamic(() => import('@/components/templates/key_value_page/key_value_page--search_distributor_lab').then(mod => mod.SearchDistributorLabPage));
const SupportPage = dynamic(() => import('@/components/templates/key_value_page/key_value_page--support').then(mod => mod.SupportPage));

export function NodeKeyValuePage({node, additionalContent}: {node: DrupalNode, additionalContent: any}): JSX.Element {
  const identifier = node?.field_kvp_page_identifier;
  const props = additionalContent?.props;

  switch (identifier) {

    case "search":
      return <SearchPage node={node} {...props}/>

    case "news":
      return <NewsPage node={node} {...props}/>

    case "events":
      return <EventsPage node={node} {...props}/>

    case "press_releases":
      return <PressReleasesPage node={node} {...props}/>

    case "document_library":
      return <DocumentLibraryPage node={node} {...props}/>

    case "contact_us":
      return <ContactUsPage node={node} {...props}/>

    // Leaving in case of future requirement.
    // case "search_distributor":
    // case "search_labs":
    // return <SearchDistributorLabPage node={node} {...props}/>

    case "support":
      // Support fetches its content client-side; it only needs the node.
      return <SupportPage node={node} {...props}/>

    default:
      return <></>
  }
}
